(function () {
  // ─── CSS immédiat ─────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    .rapi-bundles__bar-variant-number { display: none !important; }
    .rapi-bundles__bar-variant__content { display: flex !important; align-items: center; gap: 8px; }
    .rapi-injected-img {
      width: 40px; height: 40px; object-fit: cover;
      border-radius: 7px; border: 1px solid #e5e7eb;
      flex-shrink: 0; margin-right: 8px; display: block;
      transition: opacity 0.15s ease;
    }
  `;
  document.head.appendChild(style);


  // ─── Cache produits ───────────────────────────────────────────────────
  const productCache = new Map();


  function normalizeUrl(src) {
    if (!src) return null;
    return src.startsWith('//') ? 'https:' + src : src;
  }


  async function getProductContext(handle) {
    if (productCache.has(handle)) return productCache.get(handle);


    const promise = (async () => {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error();
        const product = await res.json();


        const variantImageMap = new Map();
        const variantByOptions = new Map();
        const fallbackImage = normalizeUrl(product.featured_image);


        product.variants.forEach(v => {
          const key = v.options.join('|');
          const src = normalizeUrl(v.featured_image?.src || product.featured_image);
          if (src) {
            variantImageMap.set(key, src);
            variantByOptions.set(key, v);
          }
        });


        // Précharger toutes les images distinctes
        const seen = new Set();
        product.variants.forEach(v => {
          const src = normalizeUrl(v.featured_image?.src || product.featured_image);
          if (src && !seen.has(src)) {
            seen.add(src);
            const link = document.createElement('link');
            link.rel = 'preload'; link.as = 'image'; link.href = src;
            document.head.appendChild(link);
          }
        });


        return { variantImageMap, variantByOptions, fallbackImage, product };
      } catch (e) {
        return null;
      }
    })();


    productCache.set(handle, promise);
    return promise;
  }


  // ─── Handle produit ───────────────────────────────────────────────────
  function findProductHandle(variantEl) {
    const pathHandle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
    if (pathHandle) return pathHandle;


    let el = variantEl;
    while (el && el !== document.body) {
      if (el.dataset?.productHandle) return el.dataset.productHandle;
      if (el.dataset?.handle) return el.dataset.handle;
      if (el.dataset?.url) {
        const match = el.dataset.url.match(/\/products\/([^/?#]+)/);
        if (match) return match[1];
      }
      el = el.parentElement;
    }


    const link = variantEl.querySelector('a[href*="/products/"]');
    if (link) {
      const match = link.href.match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    }


    return null;
  }


  // ─── Lire TOUTES les options sélectionnées ────────────────────────────
  // CORRECTION CLÉ : on collecte select + hidden input ensemble,
  // sans return anticipé, pour obtenir ex: ['S', 'Gris'] au lieu de ['S']
  function getSelectedOptions(variantEl) {
    const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
    if (!wrapper) return [];


    const options = [];
    const seenValues = new Set();


    function push(value) {
      if (value && value !== 'undefined' && value !== 'null' && value !== '') {
        if (!seenValues.has(value)) {
          seenValues.add(value);
          options.push(value);
        }
      }
    }


    // 1. Tous les <select> natifs
    wrapper.querySelectorAll('select').forEach(select => {
      push(select.value);
    });


    // 2. Tous les hidden inputs .rapi-select-value (couleur via swatch/dropdown)
    wrapper.querySelectorAll('input.rapi-select-value').forEach(input => {
      push(input.value);
    });


    // 3. Si toujours rien : swatches sélectionnés
    if (!options.length) {
      wrapper.querySelectorAll('.rapi-swatch-option.selected, .rapi-swatch-option.active').forEach(swatch => {
        const span = swatch.querySelector('span');
        push(
          span?.getAttribute('title') ||
          swatch.dataset.value ||
          span?.textContent?.trim()
        );
      });
    }


    // 4. Dernier recours : éléments aria-selected / data-selected
    if (!options.length) {
      wrapper.querySelectorAll('[aria-selected="true"], [data-selected="true"]').forEach(el => {
        push(el.dataset?.value || el.dataset?.optionValue || el.getAttribute('data-value') || el.textContent?.trim());
      });
    }


    return options;
  }


  // ─── Image depuis le contexte ─────────────────────────────────────────
  function computeImageUrl(ctx, options) {
    if (!ctx || !options.length) return ctx?.fallbackImage || null;


    // Essai exact
    const key = options.join('|');
    const variant = ctx.variantByOptions.get(key);
    if (variant) return normalizeUrl(variant.featured_image?.src) || ctx.variantImageMap.get(key) || ctx.fallbackImage;


    // Essai partiel (1 option sur 2 trouvée)
    for (const [k, v] of ctx.variantByOptions.entries()) {
      if (options.every(opt => k.split('|').includes(opt))) {
        return normalizeUrl(v.featured_image?.src) || ctx.fallbackImage;
      }
    }


    return ctx.fallbackImage;
  }


  // ─── État par variant ─────────────────────────────────────────────────
  const variantStates = new Map();


  async function updateVariantImage(variantEl, animate = true) {
    const state = variantStates.get(variantEl);
    if (!state) return;


    const options = getSelectedOptions(variantEl);
    if (!options.length) return;


    const newSrc = computeImageUrl(state.ctx, options);
    if (!newSrc || newSrc === state.currentSrc) return;


    state.currentSrc = newSrc;


    if (!animate) {
      state.img.src = newSrc;
      state.img.style.opacity = '1';
    } else {
      state.img.style.opacity = '0';
      const tempImg = new Image();
      tempImg.onload = () => { state.img.src = newSrc; state.img.style.opacity = '1'; };
      tempImg.onerror = () => { state.img.src = newSrc; state.img.style.opacity = '1'; };
      tempImg.src = newSrc;
    }
  }


  // ─── Mise à jour de tous les variants (synchro) ───────────────────────
  let rafPending = false;
  function scheduleUpdateAll() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      for (const [variantEl, _] of variantStates.entries()) {
        if (variantEl.isConnected) updateVariantImage(variantEl, true);
        else variantStates.delete(variantEl);
      }
    });
  }


  // ─── Injection ────────────────────────────────────────────────────────
  async function injectVariant(variantEl) {
    if (variantStates.has(variantEl)) return;


    const content = variantEl.querySelector('.rapi-bundles__bar-variant__content');
    if (!content) return;


    let img = variantEl.querySelector('.rapi-injected-img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'rapi-injected-img';
      img.style.cssText = 'width:40px;height:40px;object-fit:cover;border-radius:7px;border:1px solid #e5e7eb;flex-shrink:0;margin-right:8px;transition:opacity 0.15s ease;opacity:0';
      const selectsWrapper = content.querySelector('.rapi-bundles__bar-variant-selects');
      content.insertBefore(img, selectsWrapper || content.firstChild);
    }


    const handle = findProductHandle(variantEl);
    if (!handle) return;


    const ctx = await getProductContext(handle);
    if (!ctx) return;


    variantStates.set(variantEl, { ctx, img, currentSrc: null });


    await updateVariantImage(variantEl, false);


    // Observer sur le wrapper pour détecter les changements de valeur
    const wrapper = variantEl.querySelector('.rapi-bundles__bar-variant-selects');
    if (wrapper) {
      new MutationObserver(scheduleUpdateAll).observe(wrapper, {
        attributes: true,
        attributeFilter: ['value', 'data-selected-value', 'data-value', 'class'],
        childList: true,
        subtree: true,
      });
    }


    // Events natifs
    variantEl.addEventListener('change', scheduleUpdateAll, true);
    variantEl.addEventListener('click', (e) => {
      const target = e.target.closest(
        '[data-value], .rapi-swatch-option, .rapi-option, select, input, .rapi-dropdown-button, .rapi-dropdown-content div'
      );
      if (target) scheduleUpdateAll();
    }, true);


    // Polling léger pour attraper les changements JS directs sur .value (propriété, pas attribut)
    let lastKey = getSelectedOptions(variantEl).join('|');
    setInterval(() => {
      if (!variantEl.isConnected) return;
      const key = getSelectedOptions(variantEl).join('|');
      if (key !== lastKey) {
        lastKey = key;
        scheduleUpdateAll();
      }
    }, 150);
  }


  // ─── Init ─────────────────────────────────────────────────────────────
  function initAll() {
    document.querySelectorAll('.rapi-bundles__bar-variant').forEach(injectVariant);
  }


  new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('.rapi-bundles__bar-variant')) injectVariant(node);
        node.querySelectorAll?.('.rapi-bundles__bar-variant').forEach(injectVariant);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }


  window.forceRapiUpdate = scheduleUpdateAll;
})();
